export default __webpack_public_path__ + "a38cbd73c0b40f703c8ac0819b5c8f4b.svg";